export type Environment = 'localhost' | 'test' | 'stage' | 'sandbox' | 'production'

interface EnvironmentInfo {
  id: Environment
  name: string | null
  color: string | null
}

const environments: Record<Environment, EnvironmentInfo> = {
  localhost: {
    id: 'localhost',
    name: 'Localhost',
    color: 'orange',
  },
  test: {
    id: 'test',
    name: 'Test',
    color: 'green',
  },
  stage: {
    id: 'stage',
    name: 'Stage',
    color: 'blue',
  },
  sandbox: {
    id: 'sandbox',
    name: 'Sandbox',
    color: 'yellow',
  },
  production: {
    id: 'production',
    name: 'Production',
    color: 'primary',
  },
}

// Mitt Amili hostnames — deliberate deviation from ada-app-ui's domain map
let environmentId: undefined | Environment = undefined
switch (window.location.hostname) {
  case 'ada-customer-test.vfs.visma.com':
  case 'app-test.mittamili.se':
    environmentId = 'test'
    break
  case 'ada-customer-stage.vfs.visma.com':
  case 'app-stage.mittamili.se':
    environmentId = 'stage'
    break
  case 'ada-customer-sandbox.vfs.visma.com':
  case 'app-sandbox.mittamili.se':
    environmentId = 'sandbox'
    break
  case 'app.mittamili.se':
    environmentId = 'production'
    break
}
if (/^(localhost|127.0.0.1|\[::1])$/.test(window.location.hostname)) {
  environmentId = 'localhost'
}

function getEnvironment() {
  return environmentId != null ? environments[environmentId] : undefined
}

export default getEnvironment
